"use strict";

exports.__esModule = true;
var _ColorPicker = require("./ColorPicker");
Object.keys(_ColorPicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ColorPicker[key]) return;
  exports[key] = _ColorPicker[key];
});